"use strict";

exports.__esModule = true;
exports.default = useClient;

var _ApolloContext = _interopRequireDefault(require("./ApolloContext"));

var _react = require("react");

var _getClient = _interopRequireDefault(require("./getClient"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * This code is from
 * https://github.com/trojanowski/react-apollo-hooks/blob/master/src/index.js
 */


function useClient(clientName) {
  var clients = (0, _react.useContext)(_ApolloContext.default);
  return (0, _getClient.default)(clients, clientName);
}